import { toKebabTitleCase } from '../../../utils';
import { visualizations as vizMappings } from '../../Visualization';

const getVisualizationsPanelSchema = (visualizations = []) => {
  const schema = {
    title: {
      type: 'string',
      title: 'Title',
      default: 'Visualizations',
    },
    options: {
      type: 'object',
      properties: {
        autoPopulate: {
          title: 'Auto-populate with visualizations related to selected component',
          type: 'boolean',
          default: false,
        },
        hideToolbar: {
          title: 'Hide toolbar',
          type: 'boolean',
          default: true,
        },
        syncVisualizationTooltip: {
          title: 'Sync the visualization tooltip',
          type: 'boolean',
          default: false,
        },
        visualizationLimit: {
          title: 'Limit visualizations per panel',
          type: 'number',
          default: 10,
        },
        height: {
          type: 'string',
          title: 'Visualization height',
          enum: ['extra-small', 'small', 'medium-small', 'medium', 'large'],
          default: 'medium',
          extraText: {
            'extra-small':
              'Extra-small height will only display metric, state and status visualizations',
          },
          extraTextTriggers: ['extra-small'],
        },
        width: {
          type: 'string',
          title: 'Visualization width',
          enum: ['small', 'medium-small', 'medium', 'large'],
          default: 'medium',
        },
        visualizationTypes: {
          type: 'array',
          title: 'Visualization Types',
          description:
            'Limit auto-populated visualizations to the selected types (no selected types means that all types are allowed)',
          default: [],
          uniqueItems: true,
          isMulti: true,
          items: {
            type: 'string',
            anyOf: vizMappings.map(({ type, name }) => ({
              enum: [type],
              title: type === 'duval' ? 'Duval-Triangle' : toKebabTitleCase(type),
            })),
          },
        },
      },
    },
  };

  if (visualizations.length) {
    schema.options.properties.visualizations = {
      type: 'array',
      title: 'Visualizations',
      default: [],
      uniqueItems: true,
      isMulti: true,
      items: {
        type: 'string',
        anyOf: visualizations.map((viz) => ({
          enum: [viz.id],
          title: `${viz.name} (${viz.type})`,
        })),
      },
    };
  }

  return schema;
};

const getVisualizationsPanelAdminSchema = (visualizations = [], isExtraSmallHeight = false) => ({
  type: 'object',
  properties: {
    autoPopulate: {
      title: 'Auto-populate with visualizations related to selected component',
      type: 'boolean',
      default: false,
    },
    hideToolbar: {
      title: 'Hide toolbar',
      type: 'boolean',
      default: true,
    },
    syncVisualizationTooltip: {
      title: 'Sync the visualization tooltip',
      type: 'boolean',
      default: false,
    },
    visualizationLimit: {
      title: 'Limit visualizations per panel',
      type: 'number',
      default: 10,
    },
    visualizations: visualizations.length
      ? {
          type: 'array',
          title: 'Include specific visualizations',
          default: [],
          uniqueItems: true,
          isMulti: true,
          items: {
            type: 'string',
            anyOf: visualizations.map((viz) => ({
              enum: [viz.id],
              title: `${viz.name} (${viz.type})`,
            })),
          },
          ...(isExtraSmallHeight
            ? {
                extraText: {
                  'extra-small':
                    'Currently set to extra-small visualization height. Only metric, state, and status visualizations will be displayed.',
                },
                extraTextKey: 'extra-small',
              }
            : {}),
        }
      : {
          type: 'object',
          title: 'Visualizations',
          description: 'None available',
          properties: {},
        },
  },
});

export { getVisualizationsPanelSchema, getVisualizationsPanelAdminSchema };
